var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import CustomRadioStyle from 'nucleus-core/less/cv/RadiobuttonInput.less';
import FormBase from 'nucleus-core/less/cv/Forms.less';
import RadioButton from 'nucleus-core/forms/elements/RadioButton';
import { injectTestId } from '@cvent/nucleus-test-automation';
import PropTypes from 'prop-types';
import MultiSelectDropDown from 'nucleus-core/forms/elements/MultiSelectDropDown';
import StyleGroup from 'nucleus-core/containers/StyleGroup';
import SelectStyle from 'nucleus-core/less/cv/Select.less';
import multiSelectStyles from 'nucleus-core/less/cv/MultiSelect.less';
import { resolve } from '@cvent/nucleus-dynamic-css';
import ThemeableComponent from 'nucleus-widgets/lib/ThemeableComponent';
import { CCPA_OPTOUT_OPTIONS, DIALOG_MODE, BUTTON_TEXT } from '../../utils/ccpaUtils';
import Button from 'nucleus-core/buttons/Button';
import formatAttendeeName from '../../utils/formatAttendeeName';
var CustomFormStyles = __assign(__assign({}, CustomRadioStyle), FormBase);
var FormStyles = __assign(__assign({}, FormBase), SelectStyle);
var MultiSelectClasses = __assign(__assign({}, multiSelectStyles), { trigger: {
        trigger: multiSelectStyles.trigger
    }, menu: __assign(__assign({}, multiSelectStyles), { checkbox: {
            label: {
                label: FormStyles.label,
                hidden: FormStyles.hidden
            }
        } }) });
var CvMultiSelectyle = __assign(__assign({}, FormStyles), { multiselect: MultiSelectClasses });
var CCPADialogContent = /** @class */ (function (_super) {
    __extends(CCPADialogContent, _super);
    function CCPADialogContent(props) {
        var _this = _super.call(this, props) || this;
        _this.ccpaOptOutRadioChange = function (fieldName, newValue) {
            _this.setState({ ccpaOptOutRadioValue: newValue });
            _this.props.setOptOutRadioOptions(newValue);
        };
        _this.onGuestsSelection = function (fieldName, newValue, newOptions) {
            _this.setState({ guests: newOptions });
            _this.props.updateGuests(newOptions);
        };
        _this.getCCPAOptOutContent = function (isAttendeeRegistered, translate, style) {
            var _a = _this.props, qualifyingQuestionText = _a.qualifyingQuestionText, successfulOptOutText = _a.successfulOptOutText, unregisteredForEventText = _a.unregisteredForEventText, instructionalText = _a.instructionalText, dialogMode = _a.dialogMode, qualifyingErrorText = _a.qualifyingErrorText;
            if (dialogMode === DIALOG_MODE.SUCCESS_OPT_OUT) {
                return React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'mainText')), translate(successfulOptOutText));
            }
            else if (dialogMode === DIALOG_MODE.FAILURE_OPT_OUT) {
                return (React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'mainText')), translate('EventWidgets_Ccpa_FailureOptOutText__resx')));
            }
            else if (dialogMode === DIALOG_MODE.ADMIN_REG) {
                return (React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'mainText')), translate('EventWidgets_Ccpa_AdminRegText__resx')));
            }
            else if (dialogMode === DIALOG_MODE.SHOW_NO_CALAFORNIA_RESIDENT) {
                return (React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'mainText', 'defaultSpacing')), translate(qualifyingErrorText)));
            }
            else if (isAttendeeRegistered) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'mainText', 'defaultSpacing'), { dangerouslySetInnerHTML: { __html: translate(instructionalText) } })),
                    dialogMode === DIALOG_MODE.SHOW_QUALIFYING_QUESTION && (React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'qualifyingQuestionSpacing')),
                        React.createElement(RadioButton, { label: translate(qualifyingQuestionText), fieldName: "type-askQualifyingQuestion", name: "type-askQualifyingQuestion", classes: CustomFormStyles, display: "vertical", style: style, options: {
                                selectedValue: _this.state.ccpaOptOutRadioValue,
                                optionArray: [
                                    { name: translate('EventWidgets_GenericText_Yes__resx'), value: CCPA_OPTOUT_OPTIONS.YES },
                                    { name: translate('EventWidgets_GenericText_No__resx'), value: CCPA_OPTOUT_OPTIONS.NO }
                                ]
                            }, onChange: _this.ccpaOptOutRadioChange }))),
                    dialogMode === DIALOG_MODE.SHOW_USER_INFO && (React.createElement(React.Fragment, null,
                        React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'label', 'defaultSpacing')), translate('EventWidgets_VerifyDetails_CCPA__resx')),
                        React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'label', 'defaultSpacing')), translate('EventWidgets_Fields_FirstName__resx')),
                        React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'input')), _this.props.primaryEventRegistrationInfo.firstName),
                        React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'label', 'defaultSpacing')), translate('EventWidgets_Fields_LastName__resx')),
                        React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'input')), _this.props.primaryEventRegistrationInfo.lastName),
                        _this.props.primaryEventRegistrationInfo.emailAddress && (React.createElement(React.Fragment, null,
                            React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'label', 'defaultSpacing')), translate('EventWidgets_Fields_EmailAddress__resx')),
                            React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'input')), _this.props.primaryEventRegistrationInfo.emailAddress))),
                        _this.state.guests && _this.state.guests.length > 0 && (React.createElement("div", __assign({}, resolve(__assign({}, _this.props), 'multiselectGuests')),
                            React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'label', 'selectGuestToOptOut')), translate('EventWidgets_SelectGuests_CCPA__resx')),
                            React.createElement(StyleGroup, { classes: __assign(__assign({}, CvMultiSelectyle), _this.props.classes) },
                                React.createElement(MultiSelectDropDown, __assign({ fieldName: "guests", options: _this.state.guests, onChange: _this.onGuestsSelection }, injectTestId('multi-select-in-global-styles'), { selectedTextCallback: function (count) {
                                        return count + " " + translate('EventWidgets_GroupFlights_Selected__resx');
                                    }, enableSelectAll: false, enableDeselectAll: false, enableFilter: false })))))))));
            }
            return (React.createElement("div", __assign({}, resolve(__assign(__assign({}, _this.props), { style: style }), 'mainText', 'defaultSpacing')), translate(unregisteredForEventText)));
        };
        var getMultiSelectOptions = props.guestsEventRegistrationsInfo.map(function (item) {
            return {
                name: formatAttendeeName(item),
                checked: false,
                value: item.attendeeEntityId
            };
        });
        _this.state = {
            guests: getMultiSelectOptions,
            ccpaOptOutRadioValue: CCPA_OPTOUT_OPTIONS.YES
        };
        // we need to store the initial radio button value in parent component
        _this.props.setOptOutRadioOptions(_this.state.ccpaOptOutRadioValue);
        return _this;
    }
    CCPADialogContent.prototype.render = function () {
        var _a = this.props, isAttendeeRegistered = _a.isAttendeeRegistered, translate = _a.translate, dialogMode = _a.dialogMode, style = _a.style, classes = _a.classes, handleDialogConfirmationClick = _a.handleDialogConfirmationClick;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null, this.getCCPAOptOutContent(isAttendeeRegistered, translate, style)),
            React.createElement(Button, { classes: classes, title: translate(BUTTON_TEXT[dialogMode]), style: __assign(__assign({}, style), { button: style.button }), kind: "primary", onClick: handleDialogConfirmationClick })));
    };
    CCPADialogContent.displayName = 'CCPADialogContent';
    CCPADialogContent.propTypes = {
        primaryEventRegistrationInfo: PropTypes.object,
        isAttendeeRegistered: PropTypes.bool,
        guestsEventRegistrationsInfo: PropTypes.array,
        qualifyingQuestionText: PropTypes.string,
        qualifyingErrorText: PropTypes.string,
        successfulOptOutText: PropTypes.string,
        unregisteredForEventText: PropTypes.string,
        instructionalText: PropTypes.string,
        style: PropTypes.object,
        setOptOutRadioOptions: PropTypes.func,
        updateGuests: PropTypes.func,
        handleDialogConfirmationClick: PropTypes.func,
        dialogMode: PropTypes.string
    };
    return CCPADialogContent;
}(ThemeableComponent));
export default CCPADialogContent;
